import { render } from "./assistant_panel.vue?vue&type=template&id=e3dbbe42"
import script from "./assistant_panel.vue?vue&type=script&lang=js"
export * from "./assistant_panel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__